var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0485 20.25L10.121 13.3388L10.5278 12.8758L10.1525 12.387L3.52137 3.75H7.95552L12.0981 9.20412L12.653 9.93471L13.2587 9.24562L18.089 3.75H19.1601L13.5532 10.1289L13.1483 10.5895L13.5193 11.0778L20.4882 20.25H16.1982L11.5863 14.2515L11.0304 13.5284L10.4283 14.2136L5.12432 20.25H4.0485Z",
    fill: "#020617",
    stroke: "#020617",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.7565ff20ffba8ab799092205a2ac9ef2.svg";
export { ForwardRef as ReactComponent };